module.exports = __webpack_public_path__ + "static/media/userGuide.20c35427.pdf";